import React from 'react';
import { Check, Sparkles, Infinity as InfinityIcon } from 'lucide-react';
import { Button } from './ui/button';
import { useLang } from '../context/LangContext';

const Pricing = () => {
  const { t } = useLang();

  return (
    <section id="pricing" className="py-24 md:py-32 bg-gradient-to-b from-white via-cyan-50/40 to-white">
      <div className="max-w-[1200px] mx-auto px-5 md:px-10">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="inline-flex items-center gap-2 bg-black text-white rounded-full px-4 py-1.5 mb-6">
            <Sparkles className="w-3.5 h-3.5" />
            <span className="text-[12.5px] font-bold tracking-wider uppercase">{t.pricing.badge}</span>
          </div>
          <h2 className="text-[44px] md:text-[68px] font-black tracking-[-0.025em] leading-[1] text-neutral-900">
            {t.pricing.title}
          </h2>
          <p className="mt-6 text-[17px] text-neutral-600 leading-relaxed">{t.pricing.subtitle}</p>
        </div>

        <div className="relative max-w-3xl mx-auto">
          <div className="absolute -inset-4 bg-gradient-to-r from-cyan-300/30 via-blue-300/30 to-fuchsia-300/30 rounded-[36px] blur-2xl" />
          <div className="relative bg-white rounded-3xl border border-neutral-200 shadow-xl overflow-hidden">
            <div className="p-8 md:p-12">
              <div className="flex items-start justify-between mb-8 flex-wrap gap-4">
                <div>
                  <div className="flex items-baseline gap-2">
                    <span className="text-[72px] md:text-[96px] font-black tracking-[-0.05em] text-neutral-900 leading-none">0</span>
                    <span className="text-3xl font-bold text-neutral-400">kr</span>
                    <span className="text-[15px] font-medium text-neutral-500 ml-2">/ forever</span>
                  </div>
                  <p className="mt-3 text-[14px] text-neutral-500">{t.pricing.note}</p>
                </div>
                <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-cyan-400 to-fuchsia-500 flex items-center justify-center shadow-lg">
                  <InfinityIcon className="w-8 h-8 text-white" strokeWidth={2.5} />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-3.5 mb-10">
                {t.pricing.features.map((f, i) => (
                  <div key={i} className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-emerald-500 flex items-center justify-center flex-shrink-0">
                      <Check className="w-3 h-3 text-white" strokeWidth={3.5} />
                    </div>
                    <span className="text-[14.5px] text-neutral-800 font-medium">{f}</span>
                  </div>
                ))}
              </div>

              <Button className="w-full h-14 rounded-full bg-black hover:bg-neutral-800 text-white font-bold text-[15px] shadow-lg">
                {t.pricing.cta}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
